import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownload = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_2631_9113)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M1.6 14.8997V7.69971H0V16.4997H16V7.69971H14.4V14.8997H1.6Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M8.79986 1.2998V9.2998H7.19986V1.2998H8.79986Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M9.13298 10.0984L12.5626 6.70878L11.4379 5.5708L8.00591 8.9628L8.00027 8.96843L4.60594 5.5741L3.47458 6.70546L6.86559 10.0965C7.01407 10.2458 7.19055 10.3644 7.38495 10.4454C7.57992 10.5266 7.78904 10.5684 8.00027 10.5684C8.21147 10.5684 8.42063 10.5266 8.6156 10.4454C8.80914 10.3648 8.98491 10.2469 9.13298 10.0984Z"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_2631_9113",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 16,
				height: 16,
				fill: "white",
				transform: "translate(0 0.5)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgDownload);
export default ForwardRef;
